<template>
  <base-input-select
    v-model="internalValue"
    solo
    :label="$t('commons.color')"
    :items="items"
    background-color="white"
  >
    <template #item="{ item }">
      <v-list-item-avatar>
        <div
          class="rounded-circle d-inline-block"
          style="height: 12px; width: 12px"
          :style="{ backgroundColor: item.color }"
        ></div>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item-content>
    </template>
    <template #selection="{ item }">
      <div
        class="rounded-circle d-inline-block mr-3"
        style="height: 12px; width: 12px"
        :style="{ backgroundColor: item.color }"
      ></div>
      <div class="d-inline-block">{{ item.text }}</div>
    </template>
  </base-input-select>
</template>

<script>
import BaseInputSelect from '~/components/base/input/BaseInputSelect'
export default {
  name: 'ProductIndividualisationFieldColor',
  components: { BaseInputSelect },
  props: {
    value: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
